import { typedFetchNoImpersonate, zodValidator } from "~/api/typed-fetch";

import {
  CompaniesResponseSchema,
  CompaniesSearchSchema,
  type CompaniesSearchParams,
  type Company,
} from "../schemas";

async function getCompanies(
  params: CompaniesSearchParams,
  signal?: AbortSignal
): Promise<Company[]> {
  const response = await typedFetchNoImpersonate("/companies/", {
    validateResponse: zodValidator(CompaniesResponseSchema),
    validateSearch: zodValidator(CompaniesSearchSchema, params),
    signal,
  });

  return response.data;
}

export { getCompanies };
export type { CompaniesSearchParams as GetCompaniesParams };
